import { UseQueryOptions, useQuery } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'
import { SurveyDetails, SurveyQuestion, SurveyRecipients } from '@/models'
import { resetQueries } from '@/utils'

export type { SurveyDetails, SurveyQuestion, SurveyRecipients }

interface GetSurveyDetailsRequest {
  id: number
}

export const getSurveyDetailsQueryKey = (data: GetSurveyDetailsRequest) => ['survey-details', data]

export const getSurveyDetails = async ({ id }: GetSurveyDetailsRequest) => {
  const { data } = await authAPI.get<SurveyDetails>(`/v2/survey/${id}`)
  return data
}

export const useInvalidateSurveyDetails = (data: GetSurveyDetailsRequest) => {
  return () => resetQueries(getSurveyDetailsQueryKey(data))
}

export const useGetSurveyDetails = (
  data: GetSurveyDetailsRequest,
  options?: Omit<UseQueryOptions<SurveyDetails>, 'queryKey' | 'queryFn'>,
) => {
  return useQuery({
    ...options,
    enabled: !!data.id && (options?.enabled ?? true),
    queryFn: () => getSurveyDetails(data),
    queryKey: getSurveyDetailsQueryKey(data),
  })
}
